import React, { useEffect } from "react";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { AppInfoActions } from "../../store/AppInfo/slice";

interface SetAppVersionProps {
  children: React.ReactNode;
}

const SetAppVersion = ({ children }: SetAppVersionProps) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const appVersion = urlParams.get("app_version");
    if (appVersion) {
      dispatch(AppInfoActions.setAppInfo({ version: appVersion }));
    }
  }, [dispatch]);

  return children;
};

export default SetAppVersion;
